import BaseService from 'services/BaseService';

export default class ExternalAnchorService extends BaseService {
	_type = 'externalAnchor';
	_typeKey = 'type';
}
